var api = require("!../../../../../../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../../../../../../node_modules/css-loader/dist/cjs.js!../../../../../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../../../../../node_modules/sass-loader/dist/cjs.js!../../../../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--1-3!../../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./items.vue?vue&type=style&index=0&id=519a6e92&prod&lang=scss&scoped=true&");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};